import { genericMap2LegacyTheme } from './genericMap2LegacyTheme';
import { genericMap2Tokens } from './genericMap2Tokens';
import { propAdapter } from './propAdapter';
const map = {
  maxWidth: '--st-legacy-constants-max-width',
  // 1440
  pageHorizontalPadding: '--st-legacy-constants-page-horizontal-padding',
  // 2.5vw
  headerHeight: '--st-legacy-constants-header-height' // 64
};
export const map2Tokens = legacyThemeProperty => {
  return genericMap2Tokens(legacyThemeProperty, map);
};
export const map2LegacyTheme = (tokens, legacyThemeProperty) => {
  return genericMap2LegacyTheme(tokens, legacyThemeProperty, map);
};
export const constantPropAdapter = propAdapter(map);